// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__az02o","bigColWidth":"Table_bigColWidth__2dhU3","biggerColWidth":"Table_biggerColWidth__2KCQw","row":"Table_row__22ITI","col":"Table_col__3XXP0"};